import { useTranslation } from "react-i18next";

import { SkillProgressBadge, useSkillStatusColor } from "@/entities/skill";

import { LegendBlock, LegendItem } from "./";

export const CompetencesLegend = () => {
    const [t] = useTranslation(undefined, { keyPrefix: "features.dashboards.details.skillsProgress" });

    return (
        <LegendBlock>
            <LegendItem picto={<SkillLegendPicto status="unassigned" />} legend={t("unassigned")} />
            <LegendItem picto={<SkillLegendPicto status="assigned" />} legend={t("assigned")} />
            <LegendItem picto={<SkillLegendPicto status="acquired" />} legend={t("acquired")} />
            <LegendItem
                picto={
                    <SkillProgressBadge
                        className="mb-1 size-5 [&>svg]:size-full"
                        profile={[
                            { status: "unassigned", level: 3 },
                            { status: "unassigned", level: 2 },
                            { status: "acquired", level: 1 },
                        ]}
                    />
                }
                legend={t("legendLevel1")}
            />
            <LegendItem
                picto={
                    <SkillProgressBadge
                        className="mb-1 size-5 [&>svg]:size-full"
                        profile={[
                            { status: "unassigned", level: 3 },
                            { status: "acquired", level: 2 },
                            { status: "unassigned", level: 1 },
                        ]}
                    />
                }
                legend={t("legendLevel2")}
            />
            <LegendItem
                picto={
                    <SkillProgressBadge
                        className="mb-1 size-5 [&>svg]:size-full"
                        profile={[
                            { status: "acquired", level: 3 },
                            { status: "unassigned", level: 2 },
                            { status: "unassigned", level: 1 },
                        ]}
                    />
                }
                legend={t("legendLevel3")}
            />
        </LegendBlock>
    );
};

const SkillLegendPicto = ({ status }: { status: "assigned" | "unassigned" | "acquired" }) => {
    const skillStatusColor = useSkillStatusColor();
    return <div className="ml-ant-xxs size-4 rounded-ant-sm" style={{ backgroundColor: skillStatusColor(status) }} />;
};
